import APIService from '@/services/APIService.js';

export default {
  getAllKpis(includeExpiredRecords) {
    return APIService.apiCall().get(`/kpis-aderencias-bdgd/getAllKpis/${includeExpiredRecords}`);
  },

  getInfo() {
    return APIService.apiCall().get('/kpis-aderencias-bdgd/getInfo');
  },

  getAnos() {
    return APIService.apiCall().get('/kpis-aderencias-bdgd/getAnos');
  },

  salvar(postData) {
    return APIService.apiCall().post(`/kpis-aderencias-bdgd/salvar`, JSON.stringify(postData));
  },

  excluir(id) {
    return APIService.apiCall().get(`/kpis-aderencias-bdgd/excluir/${id}`);
  },

  executar(id) {
    return APIService.apiCall().get(`/kpis-aderencias-bdgd/executar/${id}`);
  },

  getDadosGrafico(id) {
    return APIService.apiCall().get(`/kpis-aderencias-bdgd/getDadosGrafico/${id}`);
  },

  baixar(id, config = {}) {
    return APIService.apiCall().get(`/kpis-aderencias-bdgd/baixarPlanilha/${id}`, {
      responseType: 'blob',
      timeout: 60 * 60 * 1000,
      ...config
    });
  }
};
